/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{isSome as t}from"../../../../../core/maybe.js";class e{static getStorageSpec(t){return null}static createOrUpdateRendererSchema(e,r){return t(e)&&"default"===e.type?e:{type:"default"}}static getVariation(t){return{}}static getVariationHash(t){return 0}}e.type="default",e.programSpec=null;export{e as Technique};
